import React from "react";
import {
  PaginationButton,
  PaginationButtonProps
} from "@silversea-ssc/ui-components-react";
import { useLingui } from "@lingui/react/macro";

type NextButtonProps = Omit<PaginationButtonProps, "arrow">;

export const NextButton: React.FC<NextButtonProps> = (props) => {
  const { t } = useLingui();
  return (
    <PaginationButton
      arrow="right"
      aria-label={t`Next`}
      role="button"
      {...props}
    />
  );
};
